import type { CSSProperties } from "react";

export interface CellBorderSide {
  width: number;
  style: string;
  color: string;
  drawn: boolean;
}
export interface CellBorderOverlayInput {
  top: CellBorderSide;
  right: CellBorderSide;
  bottom: CellBorderSide;
  left: CellBorderSide;
  radius: {
    topLeft: number;
    topRight: number;
    bottomLeft: number;
    bottomRight: number;
  };
}

const SIDES = ["top", "right", "bottom", "left"] as const;
const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

// One overlay per cell. Each DRAWN side is offset outward by half its width so
// the single owner-drawn stroke straddles (centres on) the shared grid line —
// making all four sides render identically (symmetric) and coincide with the
// selection overlay, which uses the same -thickness/2 straddle.
export const computeCellBorderOverlayStyle = (
  input: CellBorderOverlayInput,
): CSSProperties => {
  const style: Record<string, string | number> = {
    position: "absolute",
    boxSizing: "border-box",
    pointerEvents: "none",
    borderTopLeftRadius: input.radius.topLeft,
    borderTopRightRadius: input.radius.topRight,
    borderBottomLeftRadius: input.radius.bottomLeft,
    borderBottomRightRadius: input.radius.bottomRight,
  };
  for (const side of SIDES) {
    const s = input[side];
    if (s.drawn && s.width > 0) {
      style[side] = `${-s.width / 2}px`;
      style[`border${cap(side)}`] = `${s.width}px ${s.style} ${s.color}`;
    } else {
      style[side] = "0px";
    }
  }
  return style as CSSProperties;
};
